import React from "react";
import { motion } from "framer-motion";

const About = () => {
  return (
    <>
      <div id="about" className="section top wf-section">
        <div className="content-wrapper _2-column-grid">
          <div
            id="w-node-_387564a6-a7ba-d4d6-6484-11c9ba1512c5-a2718ffa"
            className="content-block"
          >
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="text-style-all-caps"
            >
              REDEFINING
            </motion.div>
            <motion.h1
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="heading-xlarge"
            >
              {" "}
              Content Creation
            </motion.h1>
            {/* <motion.h1 
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }} className="heading-xlarge">The Experience &amp; Flexibility</motion.h1> */}
            <motion.p
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="text-medium opacity-90"
            >
              Cloudax is a blockchain ecosystem with blockchain-intrinsic
              products and services with the goal of permeating the globe and
              driving blockchain adoption. Our ecosystem product is a crypto
              starter kit that consists of a powerful Crypto wallet,
              decentralized exchange, launchpad, and an NFT Marketplace. Our
              mission is to liberate the economy through the integration of
              institutions, people, groups, and enterprises, and to build a
              sustainable community.{" "}
            </motion.p>
            <div className="button-group">
              <motion.a
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ ease: "easeOut", duration: 1 }}
                id=""
                href="https://launchpad.cloudax.io/"
                target="_blank"
                className="button secondary w-button"
              >
                <span className="secondary-button-text large">
                  Join Presale
                </span>
              </motion.a>
              <motion.a
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ ease: "easeOut", duration: 1 }}
                id=""
                href="https://docs.cloudax.io/"
                target="_blank"
                className="button secondary w-button"
              >
                <span className="secondary-button-text large">White Paper</span>
              </motion.a>
            </div>
          </div>
          <div id="" className="image-block">
            <div className="content-wrapper _2-column-grid">
              <div className="gradient-border _16px-radius transform origin-bottom-left hover:scale-90 transition duration-300">
                <div className="quote-container flexContainer">
                  <img
                    src="images/community2.svg"
                    loading="lazy"
                    alt="man wearing yellow beanie and glasses"
                    className="quote-image small imageSmaller"
                  />
                  <div className="quote-content" style={{ padding: 0 }}>
                    <div className="quotee tabHeader">
                      <div className="text-style-all-caps">For Community.</div>
                    </div>
                    <div className="text-small">
                      Cloudax is designed to offer great financial rewards to
                      its ever-expanding participants through innovative
                      integrated suite of products.
                    </div>
                  </div>
                </div>
              </div>
              <div className="gradient-border _16px-radius transform origin-bottom-left hover:scale-90 transition duration-300">
                <div className="quote-container flexContainer">
                  <img
                    src="images/scale_community4.svg"
                    loading="lazy"
                    alt="man wearing yellow beanie and glasses"
                    className="quote-image small imageSmaller"
                  />
                  <div className="quote-content" style={{ padding: 0 }}>
                    <div className="quotee tabHeader">
                      <div className="text-style-all-caps">For Creators.</div>
                    </div>
                    <div className="text-small">
                      Cloudax provides a platform for impact, driven by
                      Wholesome and Faith-based Content Creators, and web3
                      developers. Giving them the opportunity to earn
                      future-proof rewards in crypto and nfts.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section wf-section py-44 px-8 md:pt-[5%] md:pb-[20%]" style={{ background: "#0e0f1c" }}>
        <div
          data-w-id="1fe40e74-6fc8-8525-b0c0-74d45bd249dc"
          className=" wf-section joinsectionflex"
        >
          <motion.div 
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ ease: "easeOut", duration: 1 }} className="text-center text-style-all-caps">Supported by the global faith-based Community          </motion.div>
          <motion.h1 
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ ease: "easeOut", duration: 1 }} className="heading-xlarge text-center ">
            &nbsp;
            <span className="color-text-gradient text-center">
            Explore Our Ecosystem
            </span>
          </motion.h1>
          <div className="pt-[5%] pb-[20%">
            {/* 3D Slideshow Section */}
            <section id="slideshow">
              <div className="entire-content">
                <div className="content-carrousel">
                  <figure className="shadow">
                    <div className="bg-[#f4fbff] text-black p-4" style={{ padding: 0 }}>
                      <div className="quotee tabHeader">
                        <div className="text-style-all-caps">Wallet</div>
                      </div>
                      <div className="text-base p-4">
                      Easy to use wallet designed to appeal to non-crypto educated users within the Cloudax ecosystem
                      </div>
                    </div>
                  </figure>
                  <figure className="shadow">
                    <div className="bg-[#fef8f4] text-black p-4" style={{ padding: 0 }}>
                      <div className="quotee tabHeader">
                        <div className="text-style-all-caps">NFT Marketplace</div>
                      </div>
                      <div className="text-base p-4">Native marketplace for the secondary exchange of Non- Fungible Tokens launched within the Cloudax ecosystem
                      </div>
                    </div>
                  </figure>
                  <figure className="shadow">
                    <div className="bg-[#fbf4ff] text-black p-4" style={{ padding: 0 }}>
                      <div className="quotee tabHeader">
                        <div className="text-style-all-caps">Launchpad</div>
                      </div>
                      <div className="text-base p-4">Top tier incubator for quality decentralized projects which promote, publish or offer faith based and/or wholesome utility.
                      </div>
                    </div>
                  </figure>
                  <figure className="shadow">
                    <div className="bg-[#f4fbff] text-black p-4" style={{ padding: 0 }}>
                      <div className="quotee tabHeader">
                        <div className="text-style-all-caps">Exchange</div>
                      </div>
                      <div className="text-base p-4">Top tier incubator for quality decentralized projects which promote, publish or offer faith based and/or wholesome utility.
                      </div>
                    </div>
                  </figure>
                  <figure className="shadow">
                    <div className="bg-[#f4fbff] text-black p-4" style={{ padding: 0 }}>
                      <div className="quotee tabHeader">
                        <div className="text-style-all-caps">E Commerce</div>
                      </div>
                      <div className="text-base p-4">Bridge between physical items and digital assets. Bringing liquidity to everyday items tied to your favorite cryptocurrency.
                      </div>
                    </div>
                  </figure>
                  {/* <figure className="shadow">
                    <img src="https://images.pexels.com/photos/21261/pexels-photo.jpg?w=940&h=650&auto=compress&cs=tinysrgb" />
                  </figure>
                  <figure className="shadow">
                    <img src="https://images.pexels.com/photos/567973/pexels-photo-567973.jpeg?w=940&h=650&auto=compress&cs=tinysrgb" />
                  </figure>
                  <figure className="shadow">
                    <img src="https://images.pexels.com/photos/776653/pexels-photo-776653.jpeg?w=940&h=650&auto=compress&cs=tinysrgb" />
                  </figure> */}
                </div>
                <figure class="item-content group">
                  <div class="item-img">
                    <img
                      src="../images/_cloudax_animate.png"
                      alt=""
                    />
                  </div>
                </figure>
              </div>
            </section>
          </div>
        </div>
      </div>
{/* 
      <div className="section wf-section" style={{ background: "#0e0f1c" }}>
        <div
          data-w-id="1fe40e74-6fc8-8525-b0c0-74d45bd249dc"
          className="section _50-50-full-screen wf-section joinsectionflex"
        >
          <div
            id="w-node-_1fe40e74-6fc8-8525-b0c0-74d45bd249ec-d5719002"
            className="joinsectionflexInner"
          >
            <div className="gradient-border _16px-radius">
              <motion.img
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ ease: "easeOut", duration: 1 }}
                src="images/screen-1024x618.png"
                loading="lazy"
                alt=""
                className="large"
              />
            </div>
          </div>
          <div
            id="w-node-_1fe40e74-6fc8-8525-b0c0-74d45bd249dd-d5719002"
            className="content-block padded"
          >
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="text-style-all-caps"
            >
              Join The Future
            </motion.div>
            <motion.h1
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="heading-xlarge"
            >
              What We<span className="color-text-gradient"> Envision...</span>
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="text-medium opacity-90"
            >
              A BEP-20 utility and governance token that powers our rapidly
              expanding ecosystem. Cloudax token ($CLDX) would serve several
              purposes such as Payments and Access to our Launchpad, NFT
              Marketplace, Fees Payments, ecommerce shopping, in-game purchases,
              Network incentivaztion.
            </motion.p>
            <div className="button-group">
              <a
                href="https://apple.com"
                target="_blank"
                className="w-inline-block"
              >
                <img
                  src="../images/App-Store.png"
                  loading="lazy"
                  width={120}
                  alt="apple app store logo"
                />
              </a>
              <a
                href="https://google.com"
                target="_blank"
                className="w-inline-block"
              >
                <img
                  src="../images/Google-Play.png"
                  loading="lazy"
                  width="135.5"
                  alt="google play logo"
                />
              </a>
              <a
                id=""
                href="https://docs.cloudax.io/"
                className="button secondary w-button"
                style={{ margin: 0 }}
              >
                <span className="secondary-button-text small">
                  Join Presale
                </span>
              </a>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default About;
